import React, { useCallback } from 'react';

import Checkbox from 'component/Layout/Form/Checkbox';

import classNames from 'classnames';

import { useTouroperatorListAtom } from 'hooks/form/filter';
import { useMeta } from 'hooks/form/meta';
import { useChangedFilterList } from 'hooks/form/useChangedFilterList';

import { toggleValueInSet } from 'utility/Toggle/toggleValueInSet';

import { SearchParam } from 'types/Search/params';

import styles from '../../Filter.module.scss';
import FilterLabel from '../../Segment/FilterLabel';

const List = () => {
    const [filterMeta] = useMeta();
    const [tourOperatorList, setTourOperatorList] = useTouroperatorListAtom();
    const touroperatorData = filterMeta.tourOperator;
    const { onToggle, isFilterChanged } = useChangedFilterList();

    const onSelect = useCallback(
        (selection: string) => {
            onToggle(selection);
            setTourOperatorList((current) =>
                toggleValueInSet(current, selection)
            );
        },
        [setTourOperatorList, onToggle]
    );

    if (!touroperatorData) {
        return null;
    }

    return touroperatorData.itemOrder.map((key) => {
        const operator = touroperatorData.items[key];
        const operatorMeta = operator.meta;
        const label = operator.label;
        const isChecked = tourOperatorList.has(operator.value);

        return {
            content: (
                <Checkbox
                    key={operator.value}
                    input={{
                        id: `cbTourOperator${operator.value}`,
                        value: operator.value,
                        name: `cbTourOperator${operator.value}`,
                    }}
                    isDisabled={false}
                    onChange={() => onSelect(operator.value)}
                    isChecked={isChecked}
                    withUXSelection
                    customClass={{
                        Wrapper: classNames({
                            [styles.Changed]: isFilterChanged(operator.value),
                        }),
                    }}
                >
                    <FilterLabel
                        labelText={label}
                        {...operatorMeta}
                        textOverflow
                    />
                </Checkbox>
            ),
            isSelected: isChecked,
            filterValue: label,
            kiFilterData: {
                label,
                isSelectable: !!operator.value,
                urlKey: SearchParam.TouroperatorList,
                value: operator.value ?? '',
                ...operatorMeta,
            },
        };
    });
};

export default List;
